<template>
  <component :is="cptuData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="cptuData === undefined">
      <h4 class="alert-heading">Erreur de récupération des données de CPTu</h4>
      <div class="alert-body">
        Pas de traitement CPTu trouvé sur cet identifiant. Vérifiez
        <b-link class="alert-link" :to="{ name: 'apps-cptu-list' }">
          la liste des CPTus
        </b-link>
        pour d'autres CPTus.
      </div>
    </b-alert>

    <b-tabs v-if="cptuData" pills>
      <!-- Tab: Général -->
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Traitement CPTu</span>
        </template>
        <handle-cptu-tab-general
          class="mt-2 pt-75"
          :cptu-data.sync="cptuData"
          @data-handled="$router.push({ name: 'apps-cptu-list' })"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
/* eslint-disable */
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import HandleCptuTabGeneral from "./HandleCptuTabGeneral.vue";
import useCptuList from "@/views/apps/cptu/cptu-list/useCptuList";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "HandleCptu",
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    HandleCptuTabGeneral,
  },
  setup() {
    const blankCptuData = {
      name: "",
      description: "",
    };

    const cptuData = ref(JSON.parse(JSON.stringify(blankCptuData)));

    const fetchCptu = () => {
      store
        .dispatch("cptu/fetchCptu", { id: router.currentRoute.params.id })
        .then((cptu) => {
          cptuData.value = cptu;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            cptuData.value = undefined;
          }
        });
    };

    onMounted(() => {
      if (router.currentRoute.params.id) {
        fetchCptu();
      }
    });

    return {
      cptuData,
    };
  },
};
</script>
